module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/properJsonDialog/properjsondialog.component.css
// module id = ./src/app/properJsonDialog/properjsondialog.component.css
// module chunks = main